import { tgfAudio } from "../framework/tgfAudio";
import { tgfStatus } from "../framework/tgfStatus";
var YoutubeMuteManager = /** @class */ (function () {
    function YoutubeMuteManager() {
        ytgame.system.onAudioEnabledChange(this.onAudioEnabledChange.bind(this));
    }
    Object.defineProperty(YoutubeMuteManager.prototype, "muted", {
        get: function () {
            return this._muted;
        },
        enumerable: false,
        configurable: true
    });
    YoutubeMuteManager.prototype.updateMuteState = function () {
        this.onAudioEnabledChange(ytgame.system.isAudioEnabled());
    };
    YoutubeMuteManager.prototype.onAudioEnabledChange = function (enabled) {
        this._muted = !enabled;
        if (this._muted) {
            tgfAudio.muteEffects();
            tgfAudio.muteMusic();
        }
        else {
            if (!tgfStatus.storage) {
                return;
            }
            tgfStatus.getPreferencesData().musicMuted ? tgfAudio.muteMusic() : tgfAudio.unmuteMusic();
            tgfStatus.getPreferencesData().effectsMuted ? tgfAudio.muteEffects() : tgfAudio.unmuteEffects();
        }
    };
    return YoutubeMuteManager;
}());
export var youtubeMuteManager = new YoutubeMuteManager();
